import { RouteRecordRaw } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireAuthenticated } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration, checkSitterOnboarding } from '@/router/guards/completionGuards';
import MessagesView from '@/apps/messages/MessagesView.vue';

// Unverified sitters can open the inbox. Variant B shows a composer banner and
// redirects to /verify-email instead of an in-thread verify modal.
const messagingAccessGuards = combineGuards([requireAuthenticated, checkPremiumParentRegistration, checkSitterOnboarding]);

const messagesRoutes: RouteRecordRaw[] = [
  {
    path: '/messages',
    name: 'Messages',
    component: MessagesView,
    beforeEnter: messagingAccessGuards,
    meta: { shouldHideFooter: true },
  },
];

export default messagesRoutes;
